(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Mobile, 'CompatibilityFixer')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Fixes compatibility issues.
         *
         * @memberOf Lfl.Mobile
         */
        Lfl.Mobile.CompatibilityFixer = Mobile.CompatibilityFixer || {};

        (function (CompatibilityFixer, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * Fixes.
             * @memberOf Lfl.Mobile.CompatibilityFixer
             */
            CompatibilityFixer.fix = function () {
                fix_1_11_3();
            };

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
            function fix_1_11_3() {
                if (typeof AndroidCallbacks !== 'undefined') {
                    if (typeof AndroidCallbacks.onPhotoswipeOpen === 'undefined') {
                        Lfl.Mobile.Sender.onPhotoswipeOpen = function() {};
                    }

                    if (typeof AndroidCallbacks.onPhotoswipeClosed === 'undefined') {
                        Lfl.Mobile.Sender.onPhotoswipeClosed = function() {};
                    }
                }

                if (typeof webkit !== 'undefined' && typeof webkit.messageHandlers !== 'undefined') {
                    if (typeof webkit.messageHandlers.onPhotoswipeOpen === 'undefined') {
                        Lfl.Mobile.Sender.onPhotoswipeOpen = function() {};
                    }

                    if (typeof webkit.messageHandlers.onPhotoswipeClosed === 'undefined') {
                        Lfl.Mobile.Sender.onPhotoswipeClosed = function() {};
                    }
                }
            }
        }(Mobile.CompatibilityFixer, jQuery));
    }(Lfl.Mobile, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
